<div class="orders-container">

  <!-- Header -->
  <div class="page-header">
    <h1 class="page-title">Orders</h1>

    <div class="header-actions">

      <!-- Search by Order Id -->
      <input
        type="text"
        placeholder="Search..."
        class="search-input"
        (input)="onSearchOrderId($event)"
      />

      <!-- ✅ Check All on current page -->
      <button
        class="page-btn"
        type="button"
        (click)="toggleCheckAllOnPage()"
        [disabled]="isLoading || combinedOrders.length === 0"
        [class.active]="isAllCheckedOnPage()"
        title="Select / Unselect all on this page"
      >
        {{ isAllCheckedOnPage() ? 'Uncheck All' : 'Check All' }}
      </button>

      <!-- ✅ Bulk Actions -->
      <select
        class="day-select"
        [(ngModel)]="bulkAction"
        [disabled]="isLoading || getSelectedCount() === 0"
        title="Bulk actions"
      >
        <option [ngValue]="''">Bulk Actions...</option>
        <option
          *ngFor="let status of Statuses"
          [ngValue]="status.value"
        >
          Mark as {{ status.key.replace('_', ' ') }}
        </option>
      </select>

      <button
        class="btn-edit"
        type="button"
        (click)="applyBulkAction()"
        [disabled]="isLoading || getSelectedCount() === 0"
        title="Apply bulk action"
      >
        Apply ({{ getSelectedCount() }})
      </button>

      <button
        class="page-btn"
        type="button"
        (click)="clearSelection()"
        [disabled]="isLoading || getSelectedCount() === 0"
        title="Clear selection"
      >
        Clear
      </button>

      <!-- Sorting -->
      <select class="day-select" [(ngModel)]="sortBy" (change)="reload()">
        <option [ngValue]="'id'">Sort: Combined ID</option>
        <option [ngValue]="'created_at'">Sort: Created At</option>
        <option [ngValue]="'grand_total'">Sort: Grand Total</option>
        <option [ngValue]="'type'">Sort: Type</option>
      </select>

      <select class="day-select" [(ngModel)]="sortDir" (change)="reload()">
        <option [ngValue]="'desc'">Desc</option>
        <option [ngValue]="'asc'">Asc</option>
      </select>

    </div>
  </div>

  <!-- Table -->
  <div class="orders-table">

    <!-- Table Header -->
    <div class="table-header">
      <!-- ✅ checkbox column -->
      <div class="header-cell checkbox-cell">
        <input
          type="checkbox"
          [checked]="isAllCheckedOnPage()"
          [indeterminate]="isSomeCheckedOnPage()"
          (change)="toggleCheckAllOnPage()"
          [disabled]="isLoading || combinedOrders.length === 0"
          title="Check all on this page"
        />
      </div>

      <div class="header-cell">ID</div>
      <div class="header-cell">Order Code</div>
      <div class="header-cell">Type</div>
      <div class="header-cell">User Name</div>
      <div class="header-cell">Grand Total</div>
      <div class="header-cell">Order Status</div>
      <div class="header-cell">Payment Method</div>
      <div class="header-cell">Payment Status</div>
      <div class="header-cell">Created At</div>
      <div class="header-cell actions-cell">Actions</div>
    </div>

    <!-- Loading -->
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading orders...</p>
    </div>

    <!-- Body -->
    <div class="table-body" *ngIf="!isLoading">

      <ng-container *ngFor="let co of combinedOrders">
       <!-- Combined Order Row -->
        <div class="orders-row" [class.row-selected]="isSelected(co)" (dblclick)="openOrdersModal(co)">

          <!-- ✅ row checkbox -->
          <div class="cell checkbox-cell">
            <input
              type="checkbox"
              [checked]="isSelected(co)"
              (change)="toggleRowSelection(co, $event.target.checked)"
              title="Select row"
            />
          </div>
          <div class="cell">
            <strong>{{ co.orders[0]?.id }}</strong>
          </div>
          <div class="cell">
            <strong>{{ co.orders[0]?.code }}</strong>
          </div>

          <div class="sub-cell">
            <span>
              {{ co.orders[0]?.invoice_type == 0 ? "Stocked" : "Reservation"  }}
            </span>
          </div>

          <div class="cell">
            {{ co.shipping_address_obj?.name || co.shipping_address_obj?.full_Name || co.shipping_address_obj?.fullname || "-" }}
          </div>

          <div class="cell">
            {{ co.grand_total |currency:"EGY" }}
          </div>

          <div class="sub-cell">
           <span 
            class="badge"
            [ngClass]="'badge-' + getStatusClass(co.orders[0]?.delivery_status)">
            {{ co.orders[0]?.delivery_status || "-" }}
          </span>
          </div>

          <div class="sub-cell">
            <span 
              class="badge"
              [ngClass]="'badge-' + getStatusClass(co.orders[0]?.payment_method)">
              {{ co.orders[0]?.payment_method || "-" }}
            </span>
          </div>

          <div class="sub-cell">
            <span 
              class="badge"
              [ngClass]="'badge-' + getStatusClass(co.orders[0]?.payment_status)">
              {{ co.orders[0]?.payment_status || "-" }}
            </span>
          </div>

          <div class="cell">
            {{ co.created_at | date:'yyyy-MM-dd HH:mm' }}
          </div>

          <div class="cell actions-cell">
            <div class="action-buttons">
              <button class="btn-edit" (click)="openOrdersModal(co)" title="View Orders">
                View
              </button>
              <button class="btn-delete" (click)="deleteOrder(co)" title="Delete Orders">
                Delete
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Empty -->
      <div class="empty-state" *ngIf="combinedOrders.length === 0">
        <div class="empty-icon">🧾</div>
        <p class="empty-text">No Orders found</p>
        <p class="empty-subtext">Try searching by Order ID or change sorting.</p>
      </div>

    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container" *ngIf="!isLoading && totalCount > 0">
    <div class="pagination-info">
      Showing <strong>{{ getStartIndex() }}</strong> to <strong>{{ getEndIndex() }}</strong>
      of <strong>{{ totalCount }}</strong> combined orders
    </div>

    <div class="pagination-controls">
      <button
        class="page-btn prev-btn"
        (click)="previousPage()"
        [disabled]="page === 1 || isLoading"
      >
        ‹
      </button>

      <button
        *ngFor="let p of getPageNumbers()"
        class="page-btn page-number"
        [class.active]="p === page"
        [disabled]="isLoading"
        (click)="goToPage(p)"
      >
        {{ p }}
      </button>

      <button
        class="page-btn next-btn"
        (click)="nextPage()"
        [disabled]="page === totalPages || isLoading"
      >
        ›
      </button>
    </div>
  </div>

</div>

<!-- Orders Modal -->
<div class="modal-backdrop" *ngIf="showOrdersModal">
  <div class="modal modal-lg">

    <div class="modal-header">
      <h3>
        Combined Order #{{ selectedCombined?.id }}
        <small style="opacity:.7; font-weight:400;">
          — User ID #{{ selectedCombined?.user_id }}
        </small>
      </h3>

      <button class="close-btn" (click)="closeOrdersModal()">✖</button>
    </div>

    <div class="modal-body">

      <div class="shipping-card" *ngIf="selectedCombined?.shipping_address_obj">
        <div class="shipping-header">
          <i class="bi bi-truck"></i>
          <h3>Shipping Address</h3>
        </div>

        <div class="shipping-grid">
          <div class="shipping-item">
            <span class="label">Full Name:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.name || selectedCombined?.shipping_address_obj?.full_Name || selectedCombined?.shipping_address_obj?.fullname || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Phone:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.phone || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Email:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.email || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Country:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.country || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">State:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.state || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">City:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.city || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">District:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.district || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Region Name / ID:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.region_Name || selectedCombined?.shipping_address_obj?.regionname || '—' }} (ID: {{ selectedCombined?.shipping_address_obj?.region_Id || '—' }})</span>
          </div>

          <div class="shipping-item">
            <span class="label">Region Code:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.region_Code || selectedCombined?.shipping_address_obj?.regioncode || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Address Collect:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.address_collect || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Full Address:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.address || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Postal Code / Address Code:</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.postal_Code || selectedCombined?.shipping_address_obj?.postalcode || selectedCombined?.shipping_address_obj?.code || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Coordinates (GPS):</span>
            <span class="value">{{ selectedCombined?.shipping_address_obj?.lat_Lang || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Deliver Date:</span>
            <span class="value">{{ selectedCombined?.orders[0]?.delivery_date ? (selectedCombined?.orders[0]?.delivery_date | date:'dd/MM/yyyy - hh:mm a') : '-' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Delivery Notes:</span>
            <span class="value">{{ selectedCombined?.orders[0]?.delivery_notes || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Order Notes:</span>
            <span class="value">{{ selectedCombined?.orders[0]?.order_notes || '—' }}</span>
          </div>

          <div class="shipping-item">
            <span class="label">Order Shipping Notes:</span>
            <span class="value">{{ selectedCombined?.orders[0]?.order_shipping_notes || '—' }}</span>
          </div>
          <div class="shipping-item">
            <span class="label">Order Shipping Date:</span>
            <span class="value">{{ selectedCombined?.orders[0]?.order_shipping_date || '—' }}</span>
          </div>
        </div>
      </div>

      <div class="sub-table" *ngIf="selectedCombined?.orders?.length">

        <div class="sub-header">
          <div class="sub-cell">Invoice Type</div>
          <!-- <div class="sub-cell">Code</div> -->
          <!-- <div class="sub-cell">Tracking</div> -->
          <div class="sub-cell">Payment Method</div>
          <div class="sub-cell">Payment Status</div>
          <div class="sub-cell">Order Status</div>
          <div class="sub-cell">Total</div>
          <div class="sub-cell">Products Disc.</div>
          <div class="sub-cell">Coupon Disc.</div>
          <div class="sub-cell">Shipping Cost</div>
          <div class="sub-cell">Net Total</div>
          <div class="sub-cell">Grand Total</div>
        </div>

        <ng-container *ngFor="let o of selectedCombined.orders">
          <div class="sub-row">
            <div class="sub-cell">
              <span class="badge" [class.badge-warn]="o.invoice_type == 1">
                {{ o.invoice_type == 0 ? "Stocked" : "Reservation"  }}
              </span>
            </div>
            <!-- <div class="sub-cell"><strong>{{ o.code }}</strong></div> -->
            <!-- <div class="sub-cell">{{ o.tracking_code || '—' }}</div> -->
            
            <div class="sub-cell">
              <span class="badge badge-info">{{ o.payment_method || '—' }}</span>
            </div>

            <div class="sub-cell">
              <select
                class="status-select"
                [ngClass]="{
                  'badge-warn': o.payment_status?.toLowerCase() === 'unpaid',
                  'badge-success': o.payment_status?.toLowerCase() === 'paid',
                  'badge-refunded': o.payment_status?.toLowerCase() === 'refunded'
                }"
                [(ngModel)]="o.payment_status"
                (change)="saveOldStatus(o,'payment_status');updateOrderStatus(o, 'payment_status')"
              >
                <option *ngFor="let s of payment_Statuses" [value]="s.value">
                  {{ s.key }}
                </option>
              </select>
            </div>
            <div class="sub-cell">
              <select
                class="status-select"
                [(ngModel)]="o.delivery_status"
                (change)="saveOldStatus(o,'delivery_status');updateOrderStatus(o, 'delivery_status')"
              >
                <option *ngFor="let s of order_Statuses" [value]="s.value">
                  {{ s.key }}
                </option>
              </select>
            </div>

            <div class="sub-cell">{{ o.total | currency:"EGY" }}</div>
            <div class="sub-cell">{{ o.total_products_discount | currency:"EGY" }}</div>
            <div class="sub-cell">{{ o.coupon_discount | currency:"EGY" }}</div>
            <div class="sub-cell">{{ o.shipping_cost | currency:"EGY" }}</div>
            <div class="sub-cell">{{ o.net_total | currency:"EGY" }}</div>
            <div class="sub-cell"><strong>{{ o.grand_total | currency:"EGY" }}</strong></div>
          </div>

          <div class="details-box">
            <div class="details-title">Order #{{ o.id }} Products Details</div>

            <div class="details-header">
              <div class="d-cell">Detail ID</div>
              <div class="d-cell">Prd-ID</div>
              <div class="d-cell">Prd-Img</div>
              <div class="d-cell">Prd-Name</div>
              <div class="d-cell">Note</div>
              <div class="d-cell">Qty</div>
              <div class="d-cell">Price</div>
              <div class="d-cell">Total</div>
              <div class="d-cell">Qty Disc.</div>
              <div class="d-cell">Tax</div>
              <div class="d-cell">Net</div>
              <!-- <div class="d-cell">Payment Status</div>
              <div class="d-cell">Delivery Status</div> -->
            </div>

            <div class="details-row" *ngFor="let d of o.details">
              <div class="d-cell">#{{ d.id }}</div>
              <div class="d-cell">{{ d.product_id }}</div>
              <div class="d-cell">
                <img 
                  [src]="(d.product?.thumbnail_image || d.product_image) | ImageUrlPipe" 
                  [alt]="d.product?.name || d.product_name || 'Product Image'" 
                  appImageFallback
                  style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;"
                >
              </div>
              <div class="d-cell" [title]="d.product?.name || d.product_name">
                {{ d.product?.name || d.product_name || ('Product #' + d.product_id) }}
              </div>
              <div class="d-cell" >
                {{ d.item_note || '-' }}
              </div>
              <div class="d-cell">{{ d.quantity }}</div>
              <div class="d-cell">{{ d.price | currency:"EGY" }}</div>
              <div class="d-cell">{{ d.total | currency:"EGY" }}</div>
              <div class="d-cell">{{ d.total_quantity_discount | currency:"EGY" }}</div>
              <div class="d-cell">{{ d.tax }}%</div>
              <div class="d-cell"><strong>{{ d.net | currency:"EGY" }}</strong></div>
              <!-- <div class="d-cell">
                <span class="badge" [ngClass]="'badge-' + getStatusClass(d.payment_status)">
                  {{ d.payment_status || '—' }}
                </span>
              </div>
              <div class="d-cell">
                <span class="badge" [ngClass]="'badge-' + getStatusClass(d.delivery_status)">
                  {{ d.delivery_status || '—' }}
                </span>
              </div> -->
            </div>

            <div class="empty-state" *ngIf="!o.details || o.details.length === 0">
              <div class="empty-icon">📦</div>
              <p class="empty-text">No details found for this order</p>
            </div>
          </div>

        </ng-container>
      </div>

      <div class="empty-state" *ngIf="!selectedCombined?.orders || selectedCombined.orders.length === 0">
        <div class="empty-icon">🧾</div>
        <p class="empty-text">No orders inside this combined order</p>
      </div>

    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeOrdersModal()">Close</button>
    </div>

  </div>
</div>
